import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const GLYPHS = "#XKWZ$%&@0147";

export default function ScrambleText({ text, className = "", as: Tag = "span", speed = 24 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-5%" });
  const [display, setDisplay] = useState(() => text.replace(/[^\s]/g, "\u00A0"));

  useEffect(() => {
    if (!inView) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setDisplay(text);
      return;
    }
    let frame = 0;
    const total = text.length + 7;
    const id = setInterval(() => {
      frame++;
      setDisplay(
        text
          .split("")
          .map((c, i) => {
            if (/\s/.test(c)) return c;
            if (i < frame - 5) return c;
            if (i < frame) return GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
            return "\u00A0";
          })
          .join("")
      );
      if (frame >= total) {
        setDisplay(text);
        clearInterval(id);
      }
    }, speed);
    return () => clearInterval(id);
  }, [inView, text, speed]);

  return (
    <Tag ref={ref} className={className} aria-label={text}>
      {display}
    </Tag>
  );
}
